export default "/images/vendor/flag-icon-css/flags/1x1/gw.svg?f647ba54d53db3f2e3a46a66bb84f3c7";